import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {HomePage} from "./home/HomePage";
import {SearchPage} from "./search/SearchPage";
import {PlaylistPage} from "./playlist/PlaylistPage";
import {LibraryPage} from "./library/LibraryPage";
import {ProfilePage} from "./profile/ProfilePage";

export const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="search" element={<SearchPage/>}/>
            <Route path="library" element={<LibraryPage/>}/>
            <Route path="profile" element={<ProfilePage/>}/>
            <Route path="playlists">
                <Route path=":playlistId" element={<PlaylistPage/>}/>
            </Route>
        </Routes>
    );
};
